import { useContext } from 'react';

import CallsContext from './CallsContext';

const useCalls = () => {
  const context = useContext(CallsContext);
  if (context === null) {
    throw new Error('useCalls must be used within a CallsProvider');
  }
  return context;
};

export default useCalls;
